import domReady from "@wordpress/dom-ready";
import {slideToggle} from "@roghz/slidetoggle";

domReady(() => {
    document.addEventListener("click", (e) => {
        if (!e.target.closest("#hamburger")) {
            return;
        }
        e.preventDefault();

        const mobileNav = document.querySelector(".site-header__nav");
        const headerLogo = document.querySelector(".site-header__logo");
        const body = document.querySelector("body");
        const hamburger = document.querySelector("#hamburger");
        mobileNav.classList.toggle("open");
        hamburger.classList.toggle("open");
        headerLogo.classList.toggle("open");
        body.classList.toggle("noscroll");
    });

    const mobileDropdown = document.querySelectorAll('.site-header .menu-item-has-children > a')
    mobileDropdown.forEach(el => {
        el.addEventListener("click", (e) => {
            if (window.innerWidth < 1024) {
                e.preventDefault();
                e.target.classList.toggle("open");
                slideToggle(e.target.nextElementSibling, 400);
            }
        });

    });

    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
});
